import { Module } from 'vuex';
import actions from '@vue-storefront/core/modules/checkout/store/checkout/actions';
import getters from '@vue-storefront/core/modules/checkout/store/checkout/getters';
import mutations from '@vue-storefront/core/modules/checkout/store/checkout/mutations';
import RootState from '@vue-storefront/core/types/RootState';
import CheckoutState from '@vue-storefront/core/modules/checkout/types/CheckoutState';
import checkoutInitialState from "@vue-storefront/core/modules/checkout/store/checkout/initial-state";

export const checkoutModule: Module<CheckoutState, RootState> = {
  namespaced: true,
  state: JSON.parse(JSON.stringify(checkoutInitialState)),
  getters,
  actions,
  mutations
}
